export default {
    getBankAccounts: state => state.bankAccountList
};
